let lastRequestId = 0;
const requestsByStore = new WeakMap();

/**
 * Keeps a store's request in flight outside its state, so the SSR payload
 * never carries a promise: the state holds only the returned id, and
 * `$reset()` (which clears the id) still forgets the request. Each store
 * instance keeps the latest request per slot.
 * @param {object} store
 * @param {string} slot
 * @param {Promise} promise
 * @returns {number} the request's id, for the store's state
 */
export function trackRequest(store, slot, promise) {
  lastRequestId += 1;
  const requests = requestsByStore.get(store) ?? {};
  requests[slot] = { id: lastRequestId, promise };
  requestsByStore.set(store, requests);
  return lastRequestId;
}

/**
 * The promise of the slot's request with this id, or null if the id is
 * empty or belongs to another request (for example one sent on the server).
 * @param {object} store
 * @param {string} slot
 * @param {number | null} id
 * @returns {Promise | null}
 */
export function requestInFlight(store, slot, id) {
  const request = requestsByStore.get(store)?.[slot];
  return id && request?.id === id ? request.promise : null;
}
